import React, { useState, useEffect, useContext } from 'react';
import { translate } from 'react-multi-lang';
import { Row, Col, Alert, Calendar, Button, Modal } from 'antd';
import locale_ca from 'antd/es/date-picker/locale/ca_ES';

import { MenuTriatContext } from "../../../context/menu-triat";
import { PerfilUsuariContext } from "../../../context/perfil-usuari";

import { Api } from '../../../helpers';
import NewPassword from '../../../components/PantallesObligadesInici/NewPassword';
import Empreses from './Empreses';

function DashboardPares(props){


  const [perfilUsuari, setPerfilUsuari] = useContext(PerfilUsuariContext);
  const [menuTriat, setMenuTriat] = useContext(MenuTriatContext);
  const [modalVisible, setModalVisible] = useState(false);

  const [mostrar, setMostrar] = useState(1);
  const [obligar_modificar_password, setObligar_modificar_password] = useState(false);


  const buscarDades = async () => {
    const resp = await Api.get('/resposta/pendents/pantalla/'+perfilUsuari.account.id);
    if(resp.result.success===1){
      setObligar_modificar_password(resp.data.pantalles_inici.obligar_modificar_password);
    }
  }

  useEffect(() => {
    buscarDades();
  },[]);


  useEffect(() =>{
    if(obligar_modificar_password){
      setMostrar(1);
    }
  },[obligar_modificar_password])


  const newPasswordOK = () =>{
    setObligar_modificar_password(false);
  }

  const tancarModal = e =>{
    setModalVisible(false);
  }


  const mides = {width: '100%',height: '100px'};
  const color1 = {width: mides.width, height: mides.height, backgroundColor: '#bbdefb', borderColor: '#bbdefb', color: 'rgba(0,0,0,0.87)'};
  const color2 = {width: mides.width, height: mides.height, backgroundColor: '#c5cae9', borderColor: '#c5cae9', color: 'rgba(0,0,0,0.87)'};
  const color3 = {width: mides.width, height: mides.height, backgroundColor: '#b2ebf2', borderColor: '#b2ebf2', color: 'rgba(0,0,0,0.87)'};
  const color4 = {width: mides.width, height: mides.height, backgroundColor: '#448aff', borderColor: '#448aff', color: 'rgba(0,0,0,0.87)'};
  const color5 = {width: mides.width, height: mides.height, backgroundColor: '#ef9a9a', borderColor: '#ef9a9a', color: 'rgba(0,0,0,0.87)'};
  const color6 = {width: mides.width, height: mides.height, backgroundColor: '#eeff41', borderColor: '#eeff41', color: 'rgba(0,0,0,0.87)'};

return(
  <div style={{backgroundColor: '#e0e0e0'}}>

    <Modal
      key="NewPassword"
      open={obligar_modificar_password && mostrar == 1}
      footer={null}
      width={550}
      style={{top:20, height: "350px"}}
      //style={{top:20}}
      //bodyStyle={{ height: "350px"}}
      destroyOnClose={true}
      forceRender={true}
      maskClosable={false}
      closable={false}
    >
      <NewPassword callback={newPasswordOK}/>
    </Modal>

    <Empreses />

  </div>
);
}

export default translate(DashboardPares);
